import type { ThirdPartyInvoicingContents } from '../types/thirdPartyAgreement.types';
import type { SelectionUnit } from './invoiceSelection';
import { thirdPartyAddOnId, thirdPartyServiceId } from './thirdPartyInvoicingLines';

export interface ThirdPartyInvoiceLine {
    kind: 'service' | 'add_on';
    name: string;
    contentId: number | null;
}

export function selectedThirdPartyLine(
    contents: ThirdPartyInvoicingContents | undefined,
    selection: SelectionUnit[],
): ThirdPartyInvoiceLine | null {
    const unit = selection.length === 1 ? selection[0] : undefined;
    if (!contents || !unit) return null;

    if (unit.kind === 'service') {
        const service = contents.services.find((candidate) => thirdPartyServiceId(candidate) === unit.serviceId);
        return service ? { kind: 'service', name: service.name, contentId: service.contentId } : null;
    }

    if (unit.kind === 'add_on') {
        const addOn = contents.addOns.find((candidate, index) => thirdPartyAddOnId(candidate, index) === unit.addOnId);
        return addOn ? { kind: 'add_on', name: addOn.name, contentId: addOn.contentId } : null;
    }

    return null;
}

export function isThirdPartyLineOpen(contents: ThirdPartyInvoicingContents, line: ThirdPartyInvoiceLine): boolean {
    const lines = line.kind === 'service' ? contents.services : contents.addOns;
    return lines.some((candidate) => candidate.name === line.name && candidate.contentId === line.contentId);
}

export function thirdPartyLineKey(line: ThirdPartyInvoiceLine | null): string {
    return line ? `${line.kind}:${line.contentId ?? 'none'}:${line.name}` : 'none';
}
